import type { TOC } from '@ember/component/template-only';
import PageError from '../components/page-error.gts';

interface Signature {
  Args: {};
}

const CollectionsError: TOC<Signature> = <template>
  <PageError @title="Failed to load collections" @backRoute="index" />
</template>;

export default CollectionsError;
